import { lighten } from 'polished';
import React, { AnchorHTMLAttributes } from 'react';
import styled from 'styled-components';

interface IButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  download?: boolean
}

const Container = styled.a`
  background-color: var(--blue-darker);
  color: white;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  text-decoration: none;
  text-transform: uppercase;
  width: 50%;
  &:hover {
    background-color: ${lighten(0.1, '#081D3D')};
    transition: 0.4s;
  }
`;

const ButtonDefault: React.FC<IButtonProps> = (props) => {
  return (
    <Container { ...props}>
      {props.children}
    </Container>
  );
};

export default ButtonDefault;
